import { cr, interact } from "fire-wind-water";
import { common } from "@/model/common";
import BaseComponent from "@/components/BaseComponent";
import configMixin from "@/mixin/config";
import Header from "@/components/Header";
import Banner from "@/components/Banner";
import authService from "@/services/authService";
import md5 from "js-md5";

export default {
  name: "bindLogin",
  components: {
    Header,
    Banner,
    BaseComponent,
  },
  mixins: [configMixin],
  data() {
    return {
      weChatId: common.weChatId,
      memberFormId: common.memberFormId, //  表单ID
      memberSchemaId: common.memberSchemaId,
      schemaId: common.schemaId, // 体系ID
      backUrl: common.backUrl,
      token: common.token,
      tokenInfo: "",
      verify: common.verify,
      fields: null,
      isLoad: false,
      default: "",
      headImgUrl: "",
      nickName: "",
      systermFieldNameList: [], //系统字段名字列表
      dueFields: [], //处理后字段列表
      currentField: null,
      accountFieldValue: "",
      accountErrorMsg: "",
      passwordErrorMsg: "",
      password: "",
      dropDownName: "其他登录方式",
      isSubmitting: false,
      settingBackUrl: "",
      supportNormal: true,
      supportCustom: true,
    };
  },
  methods: {
    routerBindRegister() {
      common.routerPush(this, "bindRegister", { token: this.token });
    },
    getUnique() {
      let self = this;
      authService
        .getUnique({ memberFormId: self.memberFormId })
        .then((data) => {
          window.$sk.loading.hide();
          self.default = data.content.default;
          self.fields = data.content.fields; //全部标识字段
          self.schemaId = data.content.memberSchemaId;
          self.token = common.getToken();
          self.tokenInfo = common.getTokenInfo();
          self.headImgUrl = self.tokenInfo ? self.tokenInfo.avatar : ""; //昵称赋值
          self.nickName = self.tokenInfo ? self.tokenInfo.nickname : ""; //头像赋值
          if (cr.isArray(data.content["type"])) {
            self.supportNormal = data.content["type"].indexOf("normal") > -1;
            self.supportCustom = data.content["type"].indexOf("custom") > -1;
          }
          this.convertFiled();
        });
    },
    convertFiled() {
      let self = this;
      if (self.fields.length > 0) {
        for (let i = 0; i < self.fields.length; i++) {
          if (
            self.fields[i].fieldName == "username" ||
            self.fields[i].fieldName == "mobile" ||
            self.fields[i].fieldName == "email" ||
            self.fields[i].fieldName == "identityNum"
          ) {
            self.systermFieldNameList.push(self.fields[i].displayName);
          } else {
            self.dueFields.push(self.fields[i]);
          }
        }
        if (self.systermFieldNameList.length > 0) {
          self.dueFields.push({
            displayName: self.systermFieldNameList.join("/"),
            fieldName: "",
          });
        }
        if (
          self.default == "normal" ||
          self.supportNormal ||
          !self.supportCustom
        ) {
          self.currentField = {
            displayName: self.systermFieldNameList.join("/"),
            fieldName: "",
          };
        } else {
          self.currentField = self.dueFields[0];
        }
      }
      self.isLoad = true;
      if (!self.backUrl) {
        let backUrlSetting = self.extras.backlink.href;
        self.settingBackUrl = RegExp("^https?:\\/\\/.+").test(backUrlSetting)
          ? backUrlSetting
          : "";
      }
    },
    keySubmit(e) {
      if (e.keyCode == 13) {
        this.submit();
      }
    },
    passWordChange() {
      if (!this.password) return (this.passwordErrorMsg = "请输入密码");
      return (this.passwordErrorMsg =
        this.password.length < 6 || this.password.length > 20
          ? " 请输入6-20个字符 "
          : "");
    },
    accountFieldBlur() {
      // let isError = !(
      //   this.currentField.textRegularExpression &&
      //   new RegExp(this.currentField.textRegularExpression).test(
      //     this.accountFieldValue
      //   )
      // );
      // this.accountErrorMsg = isError
      //   ? `请输入正确的${
      //     this.currentField.displayName
      //   }`
      //   : "";
      this.accountErrorMsg = this.accountFieldValue
        ? ""
        : `请输入${this.currentField.displayName};`;
    },
    submit() {
      let self = this;
      if (!self.accountFieldValue)
        return (self.accountErrorMsg =
          "请输入" + this.currentField.displayName);
      if (!self.password) return (self.passwordErrorMsg = "请输入密码");
      if (self.accountErrorMsg || self.passwordErrorMsg) return;
      self.isSubmitting = true;
      let params = {
        tenantId: self.tenantId, //int 租户Id
        schemaId: self.schemaId, //int 体系Id（选填）
        memberSchemaId: self.schemaId,
        globalUserId: common.globalUserId,
        memberFormId: self.memberFormId, //表单id
        unique: self.accountFieldValue, //string 唯一标识。可能是用户名，邮箱，手机等;记录住密码的传 cookie
        token: self.token, //string 第三方登录传 token，token时不需要密码或是动态验证码 ;
        password: self.password ? md5(self.password).toUpperCase() : "", //string 密码。账号密码的形式必传此项。
        checkCode: "", //string 动态验证码。手机或邮箱动态验证登录传此项
        loginType: self.currentField ? self.currentField.fieldName : "", //string 登录方式（选填。主要是用于标识用户名，邮箱，手机等.其他标识方式必填）
        browseInfo: interact.browseInfo,
      };
      authService.login(params).then((data) => {
        if (data.result == 0) {
          self.isSubmitting = false;
          if (data.content.sess) {
            //登录成功
            common.setSession(
              {
                session: data.content.sess,
                memberId: data.content.memberId,
              },
              7
            );
            //登录成功操作跳转
            common.removeTokenInfo(); //清除cookie
            self.afterLoginBind(data.content.status);
          } else if (data.content.status == "auditing") {
            window.$sk.tips.show("当前用户正在审核中，暂时无法绑定。");
          } else if (data.content.status == "disabled") {
            window.$sk.tips.show("当前用户已停用，暂时无法绑定。");
          }
        } else {
          self.isSubmitting = false;
          window.$sk.tips.show(data.desc);
        }
      });
    },
    afterLoginBind(status) {
      switch (status) {
        case "increase":
          //跳转至完善资料页面
          common.routerPush(this, "increase", {
            backUrl: common.backUrl,
          });
          break;
        case "normal":
          if (this.backUrl || this.settingBackUrl) {
            if (this.backUrl) {
              common.handBackUrl(common.backUrl);
            } else {
              window.$sk.goto(this.settingBackUrl);
            }
          } else {
            common.routerPush(this, "loginSuccess", { token: this.token });
          }
          break;
        default:
          break;
      }
    },
    handleChange(value) {
      let item = this.dueFields.find((o) => o.fieldName == value);
      this.currentField = item;
      this.dropDownName = item.displayName;
      this.accountErrorMsg = "";
      // this.passwordErrorMsg = "";
    },
    skUserEnd() {
      let json = window.$sk.template.get();
      common.register(json);
      this.initConfig();
      authService
        .getForNewForm({
          tenantId: common.tenantId,
          memberFormId: common.memberFormId,
          schemaId: common.schemaId,
        })
        .then((res) => {
          if (res.result != 0) return;
          let formInfo = res.content;
          common.handPage(formInfo);
          window.$sk.template.update({
            type: "link",
            data: {
              identity: 1,
              weChatId: formInfo.authWeChatId || 0,
              skObjectType: "member",
              skObjectId: self.memberFormId,
              meetingInstanceId: "",
              meetingType: "",
              skIsNotLink: "",
              memberFormId: "",
            },
          });
        });
    },
    skLinkEnd() {
      this.verify = common.getVerify(this.weChatId);
      this.getUnique();
    },
  },
  created() {
    window.$sk.loading.show();
    this.sk = window.$sk.template.module(this);
  },
  mounted() {},
  beforeDestroy() {
    this.sk.unsubscribe();
  },
};
